import { usePaymentForm } from "./PaymentFormContext";

const useInitialPaymentType = () => {
  const { state, dispatch } = usePaymentForm();
  const initialPaymentType = state?.initialPaymentType;

  const setInitialPaymentType = (type) => {
    dispatch({
      type: "setInitialPaymentType",
      payload: type,
    });
  };

  return { initialPaymentType, setInitialPaymentType };
};

export { useInitialPaymentType };
